import React, { createRef, Component } from "react";
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import CompareSwipe from "./CompareSwipe"
import { MapContainer, TileLayer,  FeatureGroup } from "react-leaflet";
import {
  Map,
  WMSTileLayer,
  ScaleControl,
  Marker,
  GeoJSON,
  Pane,
  Popup as ReactPopup,
} from "react-leaflet";
import {
  Button,
  Segment,
  Grid,
  Message,
  Icon,
  Popup,
  Menu,
} from "semantic-ui-react";
import L from "leaflet";
import Control from "react-leaflet-control";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";
import DateSlider from "./DateSlider";
import colors from "../../colors";
import urls from "../../urls";
import { isNull } from "util";
import axios from "axios";
import domain from "../../domain";
import PieChart from "../../PieChart";
import moment from "moment";
import { FadeLoader } from "react-spinners";
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import "leaflet-graphicscale/dist/Leaflet.GraphicScale.min.css";
require("leaflet-graphicscale");

library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

var label = {};
// const { BaseLayer, Overlay } = LayersControl;
const crs = L.CRS.EPSG4326;
const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

var authType = "Basic";
var username = "NhpAdmin";
var password = "nhp@1234";
var basicAuth = authType + btoa(username + ":" + password);
axios.defaults.headers.common["Authorization"] = basicAuth;
let count = 0,
  count1 = 0;
// const Dialog = withLeaflet(DialogDefault);
function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

class MapView extends Component {
  constructor(props) {
    super(props);
   
    this.state = {
     
      layers: urls.map_layer,
      url: urls.bhuvan_map,
      baselayerselected: "Map",
      minZoom: 3,
      maxZoom: 15,
      zoom: 4,
      center: [30.12539, 78.00164],
      isMenuOpened: true,
      pointInfo: null,
      wms_url: `${domain.Geoserver}/nhp_snowcomponent/wms`,
      wms_url_default: `${domain.Geoserver}/nhp_snowcomponent/wms`,
      legend: null,
      legend_overlay: null,
      legend_title: null,
      legend_array_overlay: {},
      visibleRight: false,
      isExpand: false,
      showInfo: true,
      loading: false,
      forecast: false,
      modal: false,
      bottomlayers: false,
      informationVisible: true,
      layerloading: false,
      markerenable: true,
      tableenable: false,
      graphenable: true,
      forecastResult:{},
      actualResult:{},
    };
    this.mapRef = React.createRef();
  }
  mapRef = createRef();
  tileRef = createRef();
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  loading = (e) => {
    this.setState({
      layerloading: true,
    });
  };



  changeBaseLayer = (event) => {
    let layers, url;
   // console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
        } else if (event.target.value === "Satellite") {
          layers = urls.s_layer;
          // url='http://192.168.192.103:8080/geoserver/cite/wms'
          url = urls.satellite;
        } else if (event.target.value === "Shaded Relief") {
          layers = "nhp_snowcomponent:DEM";
          // url='http://192.168.192.103:8080/geoserver/cite/wms'
          url = this.state.wms_url_default;
        } else if (event.target.value === "LULC") {
          layers = "nhp_snowcomponent:snow_lulc";
          url = this.state.wms_url_default;
        }
        //  else if (event.target.value === "Rivers") {
        //   layers = "nhp_snowcomponent:snow_river";
        //   url = this.state.wms_url_default;
        // }
        
    this.setState({
      baselayerselected: event.target.value,
      url: url,
      layers: layers,
    });
  };
  load = (e) => {
    this.setState({layerloading: false});
  };

  //zoom and rest zoom for map, so that after reset it will come to a default position
 resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setView([30.12539, 85.00164], 5); // Set the desired center and zoom level
};

  printPreview = () => {
  };

  displayInformation = () => {this.setState({ informationVisible: !this.state.informationVisible })};
  showInfo = () => {this.setState({ showInfo: !this.state.showInfo })};

  showPointInfo = () => {this.setState({ showInfo: false })}
  
  handleMark = () => {this.setState({ markerenable: true })};
    
  // inside this on click pixel for forecast is created
  onMouseOver = (e) => {
   // console.log(e);
    axios
      .get(`${domain.DBServer}/get-point-info/${e.latlng.lat}/${e.latlng.lng}`)
      .then((result) => {
        if (result) {
         if (result.data.length === 1) {
            const leafletMap = this.mapRef.current.leafletElement;
           // console.log(e.latlng);
            this.props.setLatLng(e.latlng);

            let active_layer =
              this.props.selected !== null
                ? this.props.selected.toLowerCase().split(" ").join("-") +
                  ":" +
                  this.props.selectedLayer[this.props.selected]
                : "india states";
           // console.log(active_layer);
            let wms_url =
              this.props.selected !== null
                ? `${
                    domain.Geoserver
                  }/nhp_${this.props.selected
                    .toLowerCase()
                    .split(" ")
                    .join("-")}/wms`
                : this.state.wms_url_default;

            let containerPoint = e.containerPoint;
            let bounds = leafletMap.getBounds();
            let bbox = bounds.toBBoxString();
            let width = leafletMap.getSize().x;
            let height = leafletMap.getSize().y;
            this.props.setOnClickDetails({
              xContainerPoint: containerPoint.x,
              yContainerPoint: containerPoint.y,
              height: height,
              width: width,
              bbox: bbox,
            });
            let filename= this.props.selectedLayer[this.props.selected]+'.tif'
            this.props   
              .getFeatureInfo(
              `${domain.DBServer}/get-snowhimalayan-basininfo/${e.latlng.lng}/${e.latlng.lat}`
              )
              .then((result) => {
              //  console.log("roooooooooooooo",result.data);
                if (result.data) {this.props.setStateInfo(result.data[0])} 
                else {this.props.setStateInfo(null)}
              });

//====================forecast and actual DROPDOWN==================================================

let selected_date=this.props.date_snow;
let date_temp="#";

const dateFormatRegex = /^\d{4}\d{2}\d{2}$/;
// Check if the date props is in the correct format
if (dateFormatRegex.test(selected_date)) {
  date_temp = `${selected_date.substring(0, 4)}-${selected_date.substring(4, 6)}-${selected_date.substring(6, 8)}`;
} else {
  let selected_date1=selected_date.split("-")
  date_temp=`${selected_date1[2]}-${selected_date1[1]}-${selected_date1[0]}`;
}

axios.all([
  axios.get(`${domain.DBServer}/fetch-forecast/${e.latlng.lng}/${e.latlng.lat}/${date_temp}`),
  axios.get(`${domain.DBServer}/fetch-actual/${e.latlng.lng}/${e.latlng.lat}/${date_temp}`)
]).then(axios.spread((forecastRes, actualRes) => {
  if (forecastRes && actualRes) {
    let forecastResult = forecastRes.data.map((item) => {
      return ({date:item.date,value:item.value});
    });

    let actualResult = actualRes.data.map((item) => {
      return ({date:item.date,value:item.value});
    });            

    this.setState({
      forecastResult: forecastResult,
      actualResult: actualResult
    });
    //console.log("this.state.forecastResult", this.state.forecastResult);
   // console.log("this.state.actualResult", this.state.actualResult);
  }
}));
//===========================================================================================================================================================================        
            if (this.props.selected.toLowerCase() === "snow cover fraction" ) {
              this.props.makeChartDataAvailableDaysWithDateCats(
               
                L.Projection.LonLat.project(e.latlng).y,
                L.Projection.LonLat.project(e.latlng).x,
                 this.props.startdate,
                 this.props.enddate,
               );
               this.props.handleVisibleGraphPanelOnMapClick();
             }
          } else {
            this.setState({markerenable: false});
          }
        }
      });
  };
  componentDidMount() {
    if (this.props.latlng !== null) {
      this.showInfo(); // Function to toggle info panel
    }
  }
  componentDidUpdate(prevProps, PrevState) {

    if(this.props.selectedMenu==="Snow Cover Fraction" && this.props.startdate!==prevProps.startdate )
    {this.props.makeChartDataAvailableDaysWithDateCats()
    }
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      let layer =
        this.props.selected !== null
          ? this.props.selected.toLowerCase().split(" ").join("-") +
            ":" +
            this.props.selectedLayer[this.props.selected]
          : "india states";

      let wms_url =
        this.props.selected !== null
          ? `${domain.Geoserver}/nhp_${this.props.selected
              .toLowerCase()
              .split(" ")
              .join("-")}/wms`
          : this.state.wms_url_default;
      const snf_colors_range = [
        "#f7fbff",
        "#deebf7",
        "#c6dbef",
        "#9ecae1",
        "#6baed6",
        "#4292c6",
        "#2171b5",
        "#08519c",
        "#08306b",
        "#154360",
        "#000ad5",
      ];
      const snf_grades = [
        "1-10",
        " 10-20",
        " 20-30",
        " 30-40",
        " 40-50",
        " 50-60",
        " 60-70",
        " 80-90",
        " 90-100",
      ];
      //console.log("whatisthisssssssssssssssssssssssssssssss",this.props.selected);
      let snf_img = snf_grades.map((value, key) => {
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${snf_colors_range[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      let sna_img = (
        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="sma_color_scale"></div>
          <div style={{ float: "left", paddingLeft: "5px", marginTop: "0px" }}>
            1<br />
            10
            <br />
            20
            <br />
            30
            <br />
            40
            <br />
            50
            <br />
          </div>
        </div>
      );

      if (this.props.selected === "Snow Cover Fraction") {
        this.props.setLegend(snf_img);
      } else if (
        this.props.selected === "Forecast" ||
        this.props.selected === "Actual"
      ) {
        this.props.setLegend(sna_img);
      } else {
        this.getLegendGraphic(wms_url, layer).then((legend) => {
          this.props.setLegend(legend);
        });
      }}

    if (
      this.props.swipevalue !== prevProps.swipevalue &&
      this.props.basinoverlays !== null
    ) {
      this.handleSwipeChange(this.props.swipevalue);
     }
    if (this.props.basinoverlays !== prevProps.basinoverlays) {
     }
    //  if (this.props.visibleLeft === false) {
    //    const leafletMap = this.mapRef.current.leafletElement;
    //   leafletMap.invalidateSize();
    // }
    if(this.mapRef.current){
     if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
     }
  }
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 10;
    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=dpi:100`;
    return img_src;
  }
  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
    });
  };

//=====================================================Created for Download Side Table and Piecharts in CSV Format=============================================================//
  handleDownloadCSV = () => {
    const table = document.querySelector('.table'); // Select the table element
    const rows = table.querySelectorAll('tr'); // Select all rows in the table
    const {riverselected, activeDate } = this.props;
    let csv = []; // Create an empty array to store CSV rows
    
    let filename = riverselected !== "#" ? `Basin Wise Snow Cover Area (sq.km) as on ${moment(
      activeDate,"DD MMMM YYYY").format("DD-MMM-YYYY")}` : `River Wise Snow Cover Area (sq.km) as on  ${moment(activeDate,"DD MMMM YYYY").format("DD-MMM-YYYY")}`;
    // Loop through each row in the table
    rows.forEach((row) => {let csvRow = []; // Create an empty array for each CSV row
      row.querySelectorAll('td, th').forEach((cell, index) => {
        // Loop through each cell in the row and add its text content to the CSV row array
        if (index === 2) {
          // Extract the Snow Cover Area (sq.km) data and remove commas
          const snowCoverArea = cell.innerText.replace(/,/g, '');
          csvRow.push(snowCoverArea);
        } else { csvRow.push(cell.innerText) }
      });
      csv.push(csvRow.join(',')); // Join the CSV row array into a string and push it to the CSV array
    });

    // Join all CSV rows into a single string with line breaks
    const csvContent = csv.join('\n');
    const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
//River System Wise Snow Cover Area (sq.km)

handleDownloadCSVPIE = () => {
  const { selected, activeIndex, graphenable, visibleGraphPanel_pie, daily_stats, riverselected, activeDate,tabledata} = this.props;
  if (selected === "Daily Snow Cover" && activeIndex === 0 && graphenable && visibleGraphPanel_pie && daily_stats && tabledata ) {
      // Determine the filename based on the selected graph type
      let filename = riverselected !== "#" ? `Basin Wise Snow Cover Area (%) as on ${moment( activeDate, "DD MMMM YYYY" ).format("DD-MMM-YYYY")}` : `River Wise Snow Cover Area (%) as on ${moment(
        activeDate,"DD MMMM YYYY").format("DD-MMM-YYYY")}`;
      // Calculate the total sum of snow cover values
      const totalSnowCover = daily_stats.seriesData.reduce((acc, val) => acc + val, 0);
      // Create CSV data with percentage values rounded to 1 decimal place
      const pieData = daily_stats.categories.map((category, index) => [category, `${((daily_stats.seriesData[index] / totalSnowCover) * 100).toFixed(1)}%`]);
      // Add headers
      pieData.unshift(["", ""]);
      const defaultTitle = "Default Title";
      // Convert to CSV format
      const pieCsvContent = "data:text/csv;charset=utf-8,Basin,Daily Snow Cover Area (%)" + pieData.map(row => row.join(",")).join("\n");
      // Create download link
      const pieEncodedUri = encodeURI(pieCsvContent);
      const pieLink = document.createElement("a");
      pieLink.setAttribute("href", pieEncodedUri);
      pieLink.setAttribute("download", `${filename}.csv`);
      // Trigger download
      document.body.appendChild(pieLink);
      pieLink.click();
      document.body.removeChild(pieLink);
  }
};
//==============================================================================================================================================================================//
  handleExpand = () => {
    this.setState({isExpand: !this.state.isExpand});
  };
  handleMapClick = (latlng) => {
    // Your existing code to handle the onclick event and generate the time series chart
    //console.log("Map clicked at:", latlng);
    // Implement your logic to generate the time series chart here
  };

  handleTouchStart = (e) => {
    this.swipeRef.startX = e.touches[0].clientX;
    this.swipeRef.startY = e.touches[0].clientY;
    this.swipeRef.dragging = true;
  };

  handleTouchMove = (e) => {
    if (!this.swipeRef.dragging) return;
    const deltaX = e.touches[0].clientX - this.swipeRef.startX;
    const deltaY = e.touches[0].clientY - this.swipeRef.startY;
    this.mapRef.current.leafletElement.panBy(new L.Point(-deltaX, -deltaY), { animate: false });
    this.swipeRef.startX = e.touches[0].clientX;
    this.swipeRef.startY = e.touches[0].clientY;
  };

  handleTouchEnd = () => {this.swipeRef.dragging = false};
  // Using this highlight feature you can change line width of shapefiles, make them more bold or light accordingly
  //ORIGINAL CODE FOR HIGHLIGHTLING HIMALAYAN REGION
 
 // highlightHimalayan = (feature, layer) => {
   // console.log(feature);
   // const map = this.mapRef.current.leafletElement;
   // layer.setStyle({
    //  weight: 3,
     // color: "#0000FF",
     // fillOpacity: 0,
   // });
  //  map.fitBounds(layer.getBounds());
   // console.log(window.innerHeight, window.innerWidth);
   // map.panTo([29.3333, 86.923], 8);
 // };
  //NEW CODE- WITH IHR LAYER DOTTED BLUE, BASINS- DARK RED

  highlightHimalayan = (feature, layer) => {
   // console.log(feature);
    const map = this.mapRef.current.leafletElement; 
    layer.setStyle({
      weight: 3,
      color: "#0000FF",
      fillOpacity: 0,
      //dashArray: "6, 7", // Set the dash pattern (5 pixels dash, 5 pixels gap)
    });
  
    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       //maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
    //console.log(window.innerHeight, window.innerWidth);
    map.panTo([29.3333, 86.923], 8);
  };
  
  highlightState = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 3,
      color: "#8856a7",
      fillOpacity: 0,
    });
    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       //maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
  };

  highlightBasin = (feature, layer) => {
   // console.log(feature);
    const map = this.mapRef.current.leafletElement;
   // console.log(map);
    layer.setStyle({
      weight: 3,
      //color: "#000000",
      color: "#ff0000",
      fillOpacity: 0,
    });
    // layer.on({
    //   //  click: this.clickToFeature,
    //     mouseover:this.onmouseoverFeature
    //   });

    //map.fitBounds(layer.getBounds());
    
    map.flyToBounds(layer.getBounds(), {
      animate: true, // Enables animation
      duration: 1,   // Duration in seconds (adjust as needed)
      easeLinearity: 0.25, 
       //maxZoom:6// Controls easing (default is 0.25, lower makes it smoother)
    //  padding: [50, 50] // Adds some padding around the bounds
    });
  
    if (label !== undefined) {
      map.removeLayer(label);
    }
    label = L.marker(layer.getBounds().getCenter(), {
      icon: L.divIcon({
        className: "label",
        html: `<h3 color='red'>${
          feature.properties.basin !== undefined ? feature.properties.basin : ""
        }</h3>`,
        iconSize: [100, 40],
      }),
    }).addTo(map);
  };

  handleClick_bottom = (value) => { console.log(value)};
  handleClick_tools = (value) => {
    if (value === "about") {
      this.setState({
        informationVisible: true,
      });
    }
  };
  getLegendGraphic_basic = (e) => {
    let wms_url = this.state.wms_url;
    let title, layer;
   // console.log(e.name);
    if (e.name === "Shaded Relief") {
      layer = "nhp_snowcomponent:DEM";
    } else if (e.name === "LULC") {
      layer = "nhp_snowcomonent:snow_lulc";
    }

    if (e.name === "Shaded Relief") {
      title = "Shaded Relief";
    } else if (e.name === "LULC") {
      title = "Land Use and Land Cover";
    }

   // console.log(wms_url);
    this.getLegendGraphic(wms_url, layer).then((legend) => {
      this.props.setLegend(legend);
      this.setState({
        legend_overlay: legend,
        legend_title: title,
      });
    });
  };

//code added 06-feb-2024- snow discharge_sites with following columns-THIS IS NOT WORKING----------------------------------------------------
//gid/:river/:river_basin/:latitude/:longitude/:lat/:lon

pointClick = (feature, layer) => {
 // console.log("snowpointsssss", feature);
  let popupContent =
    "<table class='table table-bordered table-sm'>" + 
    "<thead class='bg-primary text-white'><tr><th class='text-center'>River</th><th class='text-center'>River Basin</th>" +
    "<tbody><tr><td><b color='blue'>" +
    feature.properties.river +
    "</b></td><td> <b color='blue'> " +
    feature.properties.river_basin +
    "</b></td><td>" +
    "</b></td></tr></tbody></table>";
  layer.bindPopup(popupContent).openPopup();
};



render() {
  let test, test1, table_body,layer, layer_type , product, product_actual;

 // console.log("this.state.tableenable",this.props.tableenable,this.props.daily_stats, this.props.visibleTableData,this.props.tabledata,this.props.visibleGraphPanel_pie)
  let legend_bar;
  

  if (this.props.geojsonadd) {
    count = count + 1;
  }
  if (this.props.himalayan_boundary) {
    count1 = count1 + 1;
  }
    //console.log("qaaa",this.props.selectedLayer[this.props.selected]);
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    if (this.props.tabledata) {
      table_body = this.props.tabledata.map((result, key) => {
        return (
          <tr>
            <td style={{ textAlign: "right" }}>{key + 1}</td>
            <td>{result.basin}</td>
            <td style={{ textAlign: "right" }}>
              {Number(result.count).toLocaleString("en-IN")}
            </td>
          </tr>
        );
      });
    }

    if (this.props.selectedLayer[this.props.selected]) {
      let value = this.props.selectedLayer[this.props.selected];
      test = value.split("_")[1];
      test1 = value.split("_")[0];
    }

    if (this.props.legend_array_overlay) {
      if (isEmpty(this.props.legend_array_overlay)) {
        legend_bar = null;
      } else
        legend_bar = Object.keys(this.props.legend_array_overlay).map((key) => {
          return (
            <React.Fragment>
              <h4>{key}</h4>
              <img src={this.props.legend_array_overlay[key]} alt=""></img>
            </React.Fragment>
          );
        });
    }
  //  console.log(test);
   // console.log("showwwwwwwwwwwwwwwww",this.props.stateInfo);

    return (
      <>
      {!this.props.collapsed3 && 
      <Map
        ref={this.mapRef}
        center={this.state.center}
        onbaselayerchange={this.getLegendGraphic_basic}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoom={this.state.zoom}
        onclick={this.onMouseOver}
        style={{ backgroundColor: "#fff"}}
        attributionControl={false}
        crs={crs}
      >
        {/* commented by kalpana <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" /> */}
        {this.state.baselayerselected !== null ? (
          
          <WMSTileLayer 
            url={this.state.url}
            layers={this.state.layers}
            ref={this.tileRef}
            format="image/png"
            zIndex={5}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
        
 { /*================================================================================ADDED BY YOU============================================================================  */}
          {/* {this.props.basinoverlays === "Discharge Outlets" ? (
            <Pane className="GeoJSONPane">
              {" "}
              <GeoJSON
                ref="geojson"
                key={this.props.DischargePoint.features[0].gid}
                data={this.props.DischargePoint}
                pointClick={this.pointClick}
                crs={crs}
              />
            </Pane>
          ) : null} */}







          {this.props.selected !== null ? (
                      <WMSTileLayer
                        url={`${
                          domain.Geoserver
                        }/nhp_${this.props.selected
                          .toLowerCase()
                          .split(" ")
                          .join("-")}/wms`}
                        layers={
                          "nhp_" +
                          this.props.selected.toLowerCase().split(" ").join("-") +
                          ":" +
                          this.props.selectedLayer[this.props.selected]
                        }
                        format="image/png"
                        zIndex={11}
                        transparent={true}
                        onloading={this.loading}
                        onload={this.load}
                      />
                    ) : null}

{this.props.basinoverlays
  ? this.props.basinoverlays.map((layer, key) => (
    
        (layer.value === "Basin" && layer.isChecked===true) && (
         // console.log("valueeeeeeeeeeeeeeeeeeeeeeeeeeeeeebasine",layer.value),
          <WMSTileLayer
            url={`${domain.Geoserver}/nhp_snowcomponent/wms`}
            layers="DischargeOutlet"
            format="image/png"
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          />
        ) ,

        <WMSTileLayer
          url={`${domain.Geoserver}/nhp_snowcomponent/wms`}
          layers={
            layer.isChecked
              ? "nhp_snowcomponent:" + (layer.value === "River" ? "snow_river" : layer.value)
              : null
          }
          format="image/png"
          zIndex={
            layer.isChecked && this.props.arraycheck[0] === layer.value
              ? 100
              : 55 + key
          }
          key={key + "_other"}
          transparent={true}
          onloading={this.loading}
          onload={this.load}
        />
    
    ))
  : null
}


 { /*===============================================================================ENDS======================================================================================*/}

            {!isEmpty(this.props.legend_array_overlay) ? (
                      <Control position="topleft">
                      </Control>
                    ) : null}

                    {this.props.stateInfo !== null ? (
                      <GeoJSON
                        ref="geojson"
                        key={this.props.stateInfo.key}
                        data={this.props.stateInfo.geojson}
                        onEachFeature={this.highlightState}
                        crs={crs}
                      />
                    ) : null}
                    {this.props.himalayan_boundary !== null ? (
                      <GeoJSON
                        ref="geojson"
                        //  key={count1+1}
                        data={this.props.himalayan_boundary}
                        onEachFeature={this.highlightHimalayan}
                        crs={crs}
                      />
                    ) : null}

        {this.props.geojsonadd !== null &&
        this.props.selected === "Daily Snow Cover" ? (
          <GeoJSON
            ref="geojson"
            key={this.props.geojsonadd.features[0].id}
            data={this.props.geojsonadd}
            onEachFeature={this.highlightBasin}
          />
        ) : null}
        {this.props.river_boundary !== null &&
        this.props.selected === "Daily Snow Cover" ? (
          <GeoJSON
            ref="geojson"
            key={this.props.river_boundary.features[0].id}
            data={this.props.river_boundary}
            onEachFeature={this.highlightBasin}
            // crs={crs}
            // zIndex={10}
            // transparent={true}
          />
        ) : null}
        {this.props.latlng !== null ? (
          <Marker
            position={
              this.props.latlng.lat && this.props.latlng.lng
                ? [this.props.latlng.lat, this.props.latlng.lng]
                : [0, 0]
            }
          />
        ) : null}
        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        <Control position="topleft" className="box-header">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>
{/* =================================================================================================================================================================== */}  
 {/* SUGGESTION i INFORMATION VALUES-For displaying information, for each tab differently created. FOR SNOW COVER FRACTION- new one on 20 ,march 2024*/}

<Control position="topleft" className="box-header">
  {this.state.showInfo || this.props.latlng !== null ? (
    <div
      style={{
        marginRight: "0px",
        paddingLeft: "0rem",
        paddingRight: "0rem",
        marginLeft: "0px",
      }}
    >
{/*     
     <Button
  basic
  attached="right"
  floated="right"
  size="tiny"
  compact
  style={{ padding: "5px" }}
  onClick={this.showPointInfo}
  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
>
  <FontAwesomeIcon icon="window-close" size="lg"/>
</Button> */}

      <Message
        icon="map marker alternate"
        info
        warning={isNull(this.props.pointInfo)}
        attached="bottom"
        color={isNull(this.props.pointInfo) ? "white" : "white"}
      >
        <Icon name="map marker alternate" />
        {this.props.stateInfo !== null ? (
          <Message.Content>
            <Message.Header>{this.props.selected}</Message.Header>
            {this.props.selected === "Daily Snow Cover" ? (
              <>
                <b>Date:</b>&nbsp;{this.props.activeDate}
                <div>
                  <b>River System:</b>&nbsp;
                  {this.props.stateInfo.river_syst
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.replace(word[0], word[0].toUpperCase()))
                    .join(" ")}
                </div>
                <b>Basin:</b>&nbsp;{this.props.stateInfo.basin}
              </>
            ) : this.props.selected === "Snow Cover Fraction" ? (
              <>  
                <div> <b>Date:</b>&nbsp;{this.props.activeDate}</div>
                <b>Pixel Value:</b>&nbsp;{this.props.pointInfo !== null ? parseInt(this.props.pointInfo) : null} %
                <div>
                  <b>River System:</b>&nbsp;
                  {this.props.stateInfo.river_syst
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.replace(word[0], word[0].toUpperCase()))
                    .join(" ")}
                </div>
                <b>Basin:</b>&nbsp;{this.props.stateInfo.basin}
              </>

) : this.props.selected === "Forecast" ? (
  <> 
    <b>Date:</b>&nbsp;{moment(this.props.forecastdate, "DD-MM-YYYY").format("DD MMMM YYYY")}
    <div>
      <b>River System:</b>&nbsp;
      {this.props.stateInfo.river_syst
        .toLowerCase()
        .split(" ")
        .map((word) => word.replace(word[0], word[0].toUpperCase()))
        .join(" ")}
    </div>
    <b>Basin:</b>&nbsp;{this.props.stateInfo.basin}
    {this.state.forecastResult.map((res, index) => (
    //console.log("haryyy",this.props.forecastdate,res.date,res.value),

      <div key={index}>

        <b>Pixel Value for {res.date}:</b>&nbsp;{res.value.toFixed(2)} (mm/day)
       
      </div>
    ))}

  </>
  

            ) : this.props.selected === "Actual" ? (
              <>
                <b>Date:</b>&nbsp;{this.props.activeDate}
                <div>
                  <b>River System:</b>&nbsp;
                  {this.props.stateInfo.river_syst
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.replace(word[0], word[0].toUpperCase()))
                    .join(" ")}
                </div>
                <b>Basin:</b>&nbsp;{this.props.stateInfo.basin}
                {this.state.actualResult.map((res, index) => (
                //console.log("haryyy",this.props.forecastdate,res.date,res.value),
                  <div key={index}>
                    <b>Pixel Value for {res.date} </b>:&nbsp;{res.value.toFixed(2)} (mm/day)
                  </div>
                ))}
              </>
            ) : null}
          </Message.Content>
        ) : (
          "Click Anywhere in Himalayan Boundary"
        )}
      </Message>
    </div>
  ) : (
    <Popup
      trigger={
        <Button
          size="tiny"
          compact
          style={{ padding: "8px" }}
          onClick={this.showInfo}
          //onClick={() => this.setState({ showInfo: true })}
        >
          <FontAwesomeIcon icon="info-circle" size="lg" />
        </Button>
      }
      position="right center"
     
    >
      <Popup.Content>Map Inspection</Popup.Content>
    </Popup>
  )}
</Control>

{/* =================================================================================================================================================================== */}
        {window.innerWidth>1000?
        <Control position="topleft">
          <Button
            onClick={this.props.handleAnimationChange}
            secondary
            style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
            attached="right"
            compact
            size="mini"
            //title="Minimize/Maximize Product Selection Panel"
            title="Show or Hide Product Selection Panel
"
          >
            <FontAwesomeIcon icon="th-list" size="sm" />
          </Button>
        </Control>: <Control position="bottomleft">
          <Button
            onClick={this.props.handleAnimationChange}
            secondary
            style={{ backgroundColor: colors.graphical , marginLeft: "-10px" }}
            attached="right"
            compact
            size="mini"
            //title="Minimize/Maximize Product Selection Panel"
            title="Show or Hide Product Selection Panel
"
          >
            <FontAwesomeIcon icon="th-list" size="sm" />
          </Button>
        </Control>}


{/* ===============USING THIS GRAPHICAL ANALYSIS IS TURNED OFF=================== */}
{!this.props.visibleGraphPanel && !this.props.visibleGraphPanel_pie && this.props.chartData!==null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel}
                  secondary
                  style={{ backgroundColor: colors.graphical  }}
                  compact
                  size="small"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}

        <MouseControl position="bottomleft" />
        <Control
          position="bottomleft"
          style={{ pointerEvents: "auto", cursor: "auto" }}
        >
          {this.props.slider ? (
            <DateSlider {...this.props.sliderOptions} />
          ) : null}
        </Control>
        <ScaleControl metric={true} className="toolbar" />

        <Control position="topright">
          <OffCanvas
            width={300}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "50px",
                marginRight: "10px",
                //overflowY: "auto", /* Allows vertical scrolling if content overflows */

            
              }}
              transitionDuration={300}
              // isMenuOpened={this.state.isMenuOpened}
            >
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.props.displayBaseLayers}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Layers
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                        
                      }}
                    >
                      {this.props.baseLayers ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                    </div>
                  </div>
                </Menu.Item>
              </div>
              {this.props.baseLayers ? (
                <div  style={{  backgroundColor:colors.final_side_sub}}>
                  <input
                    type="radio"
                    name="baselayer"
                    value="Satellite"
                    checked={this.state.baselayerselected === "Satellite"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Satellite <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="Map"
                    checked={this.state.baselayerselected === "Map"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Map <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="Shaded Relief"
                    checked={this.state.baselayerselected === "Shaded Relief"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  Shaded Relief <br />
                  <input
                    type="radio"
                    name="baselayer"
                    value="LULC"
                    checked={this.state.baselayerselected === "LULC"}
                    onChange={this.changeBaseLayer}
                  />{" "}
                  LULC <br />
                  
                  <input
                    type="checkbox"
                    name="C_baselayer"
                    value="GlacierBlue"
                    checked={this.props.isChecked}
                    onChange={this.props.handleCheckChieldElement}
                  />{" "}
                   Glaciers <br />

          
 
                   <input
                    type="checkbox"
                    name="C_baselayer"
                    value="River"
                    checked={this.props.isChecked}
                    onChange={this.props.handleCheckChieldElement}
                  />{" "}
                   River <br />
                
                   {/* <input
                    type="checkbox"
                    name="C_baselayer"
                    value="Basin"
                    checked={this.props.isChecked}
                    onChange={this.props.handleCheckChieldElement}
                  />{" "}
                   Basins  <br /> 

                   <input
                    type="checkbox"
                    name="C_baselayer"
                    value="DischargeOutlet"
                    checked={this.props.isChecked}
                    onChange={this.props.handleCheckChieldElement}
                  />{" "}
                   Discharge Outlets <br />  */}
                    
                          <input
        type="checkbox"
        name="C_baselayer"
        value="Basin_DischargeOutlet" // Combined value for both layers
        checked={this.props.isChecked}
        onChange={this.props.handleCheckChieldElement}
      />{" "}
      Basins & Discharge Outlets <br />

             
                </div>
              ) : null}

              <div></div>
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.props.displayLegend}
                  style={{ textAlign: "center", marginLeft: `5px`}}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.textcolor,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Legend
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                      }}
                    >
                      {this.props.legendVisible ? (
                        <FontAwesomeIcon icon="angle-down" />
                      ) : (
                        <FontAwesomeIcon icon="angle-right" />
                      )}
                    </div>
                  </div>
                </Menu.Item>
              </div>

{/*=================================Trial version Collapsed Window SWIPE===================================*/}
 
              {this.props.legendVisible ? (
                <React.Fragment>
                  {/* <center  //style={{  backgroundColor:colors.final_side}}> */}
                    <center>
                    {test === "smf" ? (
                      <p style={{ fontWeight: "600", fontSize: "14px" }}>
                        Snowmelt Rate Forecast (mm/day) <br />for &nbsp;
                        {moment(this.props.forecastdate, "DD-MM-YYYY").format(
                          "DD MMMM YYYY"
                        )}
                        <br />
                        Forecast given on {this.props.activeDate}{" "}
                      </p>
                    ) : test1 === "snowcover" ? (
                      <p style={{ fontWeight: "600", fontSize: "14px" }}>
                        {" "}
                        Snow Cover <br />
                        {this.props.activeDate}{" "}
                      </p>
                    ) : test === "snf" ? (
                      <p style={{ fontWeight: "600", fontSize: "14px" }}>
                        Snowcover Fraction <br /> &nbsp; {this.props.activeDate}{" "}
                      </p>
                    ) : test === "sma" ? (
                      <p style={{ fontWeight: "600", fontSize: "14px" }}>
                        {" "}
                        Daily Snowmelt Rate (mm/day) <br />on &nbsp;{" "}
                        {this.props.activeDate}{" "}
                      </p>
                    ) : null}{" "}
                    {test === "snf" ? (
                      <div className="info legend">{this.props.legend}</div>
                    ) : test === "smf" || test === "sma" ? (
                      this.props.legend

                    ) : test1 === "snowcover" ? (
                      <img src={this.props.legend} alt="" />

                    ) : null}
                  </center>
                </React.Fragment>
              ) : null}

              {this.props.selected === "Daily Snow Cover" &&
              this.props.activeIndex === 0 ? (
               // console.log ("hagggggg",this.props.selected),
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.props.toggleVisibleGraphPanel_pie}
                    style={{ textAlign: "center", marginLeft: `5px`, }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.textcolor,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Snow Cover Area Statistics
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {((this.props.visibleGraphPanel_pie) &&
                       ( this.props.daily_stats !== null|| this.props.tabledata!== null))? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>
              ) : null
                        }
              
              {this.props.selected === "Daily Snow Cover" &&
              this.props.activeIndex === 0 &&
              this.props.graphenable &&
              this.props.visibleGraphPanel_pie &&
              (this.props.daily_stats!==null || this.props.tabledata!== null) ? (
           
                // <div style={{  backgroundColor:colors.final_side_sub,height: '40vh' ,
                // overflowY: 'auto' ,
                // width: '100%' ,
                // boxSizing: 'border-box' ,
                // padding: '5px',   scrollPaddingBottom: "5px" }} >  
                <div style={{
                 // backgroundColor: colors.final_side_sub,
                  height: '40vh',
                  minHeight: '40vh',
                  overflowY: 'auto',
                  width: '100%',
                  boxSizing: 'border-box',
                  padding: '5px',
                  scrollPaddingBottom: '5px',
                  //marginTop: '20px', // Adjust this if you need spacing from the top
              }}>
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bolder",
                      fontSize: "14px",
                      marginBottom:"0rem"

                     
                    }}
                    //This Part responsible for table title changes like- River SystemWise and Basin SystemWise Title
                    >
                    {" "} 
                    
                    { this.props.riverselected!=="#" && (     
                     "Basin Wise Snow Cover Area (%)") }
                      { this.props.riverselected==="#" && ( 
                      "River System Wise Snow Cover Area (%)") }
                  </p>
                  
                  <p
                    style={{
                      textAlign: "center",
                      fontWeight: "bolder",
                      fontSize: "14px",
                      marginBottom:"-2rem"


                    }}
                  >
                    {" "}
                    {this.props.activeDate}
                  </p>
                  <p
                    style={{
                      display: "flex",
                      justifyContent: "space-between", // Aligns the content to both sides
                      textAlign: "right",
                      fontWeight: "bolder",
                      fontSize: "14px",
                      cursor: "pointer",
                      textDecoration: "underline",
                      marginTop:"1rem",
                      
                    }}
                    
                    onClick={this.props.toggleSnowCover}

                  >
                    
                    <span style={{ paddingleft: "1rem",
                      marginLeft:"1rem"
                     }}>
    {this.props.tableenable ? "Graph" : "Table"}
  </span>                    <button className="download-button"    style={{
                 cursor: "pointer" }} onClick={this.handleDownloadCSVPIE} >
                 
                 <FontAwesomeIcon icon={faDownload} size="2rem" color="blue" />
              
               </button>
                  </p>
                 

                  <PieChart {...this.props.daily_stats} />
                
                  
   {/*This was the button initially you created Download CSV button============= <FontAwesomeIcon icon="download" size="lg" color="blue" }
                    <button onClick={this.handleDownloadCSV}>
        Download Data as CSV
      </button> */}
  
                </div> 
              ) : this.props.selected === "Daily Snow Cover" &&
              this.props.activeIndex === 0 &&
              this.props.tableenable && this.props.visibleGraphPanel_pie &&
              this.props.visibleTableData ? (
                <div style={{
                  backgroundColor: colors.final_side_sub,
                  height: '40vh',
                  minHeight: '40vh',
                  overflowY: 'auto',
                  width: '100%',
                  boxSizing: 'border-box',
                  padding: '5px',
                  scrollPaddingBottom: '5px',
                  //marginTop: '20px', // Adjust this if you need spacing from the top
              }} >  <p
                  style={{
                    textAlign: "center",
                    fontWeight: "bolder",
                    fontSize: "14px",
                    marginBottom:"0rem"

                  }}
                >
                    {" "}
                    { this.props.riverselected!=="#" && (
                     "Basin Wise Snow Cover Area (sq.km)") }
                      { this.props.riverselected==="#" && (
                      "River System Wise Snow Cover Area (sq.km)") }

                  </p>
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: "bolder",
                    fontSize: "14px",
                    marginBottom:"-2rem"
                  }}
                >
                  {" "}
                  {this.props.activeDate}
                </p>
                
                <p
                  style={{
                    display: "flex",
                    justifyContent: "space-between", // Aligns the content to both sides
                   
                    textAlign: "right",
                    fontWeight: "bolder",
                    fontSize: "14px",
                    cursor: "pointer",
                    textDecoration: "underline",
                    marginTop:"1rem",

                  }}
                  onClick={this.props.toggleSnowCover}
                >
                  <span style={{ paddingleft: "1rem", marginLeft:"1rem"}}>
                     {this.props.tableenable ? "Graph" : "Table"}
                     </span>           
                  <button className="download-button" style={{
                 cursor: "pointer" }} onClick={this.handleDownloadCSV} >
                 
                 <FontAwesomeIcon icon={faDownload} size="2rem" color="blue"/>
                
               </button>
                </p>
                <table class="table"   >
                  <thead className="thead-light">
                    <tr>
                      <th scope="col"
                        style={{ textAlign: "center",fontWeight: "bolder" }}
                      >
                        S. No.{" "}
                      </th>
                      <th
                        scope="col"
                        style={{ textAlign: "center",fontWeight: "bolder"}}
                      >
                        Basin
                      </th>
                      <th
                        scope="col"
                        style={{textAlign: "center",fontWeight: "bolder"}}
                      >
                        Snow Cover Area (sq.km)
                      </th>
                    </tr>
                  </thead>
                  <tbody>{table_body}</tbody>
                </table>{" "}
                
              
                {/* Download CSV button */}
                {/* <button
  onClick={this.handleDownloadCSV}
  style={{ backgroundColor: '#6495ED', color: 'white', border: 'none', cursor: 'pointer', fontSize: '13px'}}
>
  Download BasinWise Statistics
</button> */}
              </div>
              // ) : this.props.selected === "Daily Snow Cover" &&
              // this.props.activeIndex === 0 &&
              // this.props.tableenable && 
              // this.props.visibleTableData ? (
              //   console.log ("rawwwwww",this.props.selected),
              //   <div style={{ height: "360px", width:"300px", overflowY: "scroll", scrollbarWidth: "thick", scrollbarColor: "grey white" }}>
              //   <p
              //     style={{ textAlign: "center",fontWeight: "bolder",fontSize: "14px"}}
              //   >
              //     {" "}
              //     Riverwise Snow Cover Area (sq. km){" "}
              //   </p>
              //   <p
              //     style={{ textAlign: "center",fontWeight: "bolder",fontSize: "14px" }}
              //   >
              //     {" "}
              //     {this.props.activeDate}
              //   </p>
              //   <p
              //     style={{
              //       textAlign: "right",
              //       fontWeight: "bolder",
              //       fontSize: "14px",
              //       cursor: "pointer",
              //       textDecoration: "underline",
              //     }}
              //     onClick={this.props.toggleSnowCover}
              //   >
              //     {this.props.tableenable ? "Graph" : "Table"}
              //   </p>
              //   <table class="table">
              //     <thead className="thead-light">
              //       <tr>
              //         <th
              //           scope="col"
              //           style={{textAlign: "center",fontWeight: "bolder"}}
              //         >
              //           S. No.{" "}
              //         </th>
              //         <th
              //           scope="col"
              //           style={{ textAlign: "center",fontWeight: "bolder"}}
              //         >
              //           Basin
              //         </th>
              //         <th
              //           scope="col"
              //           style={{textAlign: "center",fontWeight: "bolder"}}
              //         >
              //           Snow Cover Area (sq.km)
              //         </th>
              //       </tr>
              //     </thead>
              //     <tbody>{table_body}</tbody>
              //   </table>{" "}
              //   <button className="download-button" onClick={this.handleDownloadCSV}  style={{ width: '150px' }}>
                 
              //    <FontAwesomeIcon icon={faDownload} size="lg" color="blue"/>
              //    Download
              //  </button>
              // </div>
              
            ) : null}
      
            </OffCanvasMenu>
          </OffCanvas>
        </Control>
      </Map>
}
      
      {this.props.collapsed3 && (

        <CompareSwipe
        basinoverlays={this.props.basinoverlays}
        baselayerselected={this.props.baselayerselected}
        displayBaseLayerPanel={this.props.displayBaseLayerPanel}
        baseLayers={this.props.baseLayers}
        changeBaseLayer={this.state.changeBaseLayer}
        handleAnimationChange={this.props.handleAnimationChange}

        ref={this.mapRef}
        selected={this.props.selected}

        collapsed3={this.props.collapsed3}
        snowproductselected={this.props.snowproductselected}
        himalayan_boundary={this.props.himalayan_boundary}
        center={this.props.center}
        minZoom={this.props.minZoom}
        maxZoom={this.props.maxZoom}
        zoom={this.props.zoom}
        onclick={this.handleMapClick} 
        legend={this.props.legend}
        
       
        compareLeftDate={this.props.compareLeftDate}
        compareLeftWorkspace={this.props.compareLeftWorkspace}
        compareLeftLayer={this.props.compareLeftLayer}

        compareRightDate={this.props.compareRightDate}
        compareRightWorkspace={this.props.compareRightWorkspace}
        compareRightLayer={this.props.compareRightLayer}
        
        style={{ backgroundColor: "#fff" }}
        attributionControl={this.props.attributionControl}
        crs={this.props.crs}
        
        layers={this.props.layers}
        url={this.props.url}
        format="image/png"
        transparent={true}
        zIndex={1}
        onloading={this.loading}
        boundary={this.props.india_states_boundary}
        onload={this.load}
        wms2Url={`${domain.Geoserver}/nhp_snowcomponent/wms`}
        wms2Layers={`nhp_${layer}`}
     
        zIndex={500} 
        ref={this.tileRef}
        isMenuOpened={this.state.isMenuOpened}
       
            
        />
      )}
      </>
    );
  }
}
export default MapView;


